import { Injectable } from '@angular/core';
import { AsyncExporter, ExporterDescriptor } from '../models/exporter';
import { GitlabOptionsComponent } from '../components/gitlab-options/gitlab-options.component';

/**
 * GitLab Exporter (descriptor solo).
 *
 * Toda la lógica del push vive en el backend (workers/handlers/gitlab.handler.js).
 * El frontend solo declara:
 *   - mode: 'async'                            → encolado a `/api/exports/jobs`
 *   - requiredPermission: integration:gitlab:push → RBAC frontend
 *   - requiresIntegration: 'gitlab'            → panel renderiza chip OAuth
 *   - optionsComponent: GitlabOptionsComponent → sub-formulario montado dinámicamente
 *   - supportsExtras: true                     → toggle "Incluir campos completos"
 *
 * Icono: "open in new" (path Material) — sin usar el logo Tanuki de GitLab
 * (trademark). Genérico y semánticamente correcto para "push a sistema externo",
 * coherente con el icono usado por Jira.
 *
 * @author Marcos Cordo
 * @version 11/06/2026_1
 */
@Injectable({ providedIn: 'root' })
export class GitlabExporter implements AsyncExporter {
  readonly descriptor: ExporterDescriptor & { mode: 'async' } = {
    id: 'gitlab',
    label: 'GitLab',
    shortHint: 'Crear issues',
    iconSvgPath:
      'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z',
    mode: 'async',
    requiredPermission: 'integration:gitlab:push',
    requiresIntegration: 'gitlab',
    supportsExtras: true,
    optionsComponent: GitlabOptionsComponent,
    order: 50
  };
}
